export const DEFAULT_RBAC_PERMISSIONS = {
  "staff": {
    "events": {
      "read": false,
      "write": false,
      "delete": true
    },
    "payouts": {
      "read": false,
      "write": false,
      "delete": false
    },
    "documents": {
      "read": false,
      "write": false,
      "delete": true
    },
    "staffList": {
      "read": false,
      "write": false,
      "delete": true
    },
    "attendance": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "users": {
    "guests": {
      "read": false,
      "write": false,
      "delete": true
    },
    "parents": {
      "read": false,
      "write": false,
      "delete": true
    },
    "visitors": {
      "read": false,
      "write": false,
      "delete": true
    }
  },
  "finance": {
    "financeList": {
      "read": false,
      "write": false,
      "delete": false
    },
    "scholarships": {
      "read": false,
      "write": false,
      "delete": false
    },
    "financialReports": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "profile": {
    "leaves": {
      "read": false,
      "write": false,
      "delete": false
    },
    "calendar": {
      "read": false,
      "write": false,
      "delete": true
    },
    "documents": {
      "read": false,
      "write": false,
      "delete": true
    },
    "personalDetails": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "guardian": {
    "fees": {
      "read": false,
      "write": false,
      "delete": false
    },
    "profile": {
      "read": false,
      "write": false,
      "delete": false
    },
    "concerns": {
      "read": false,
      "write": false,
      "delete": false
    },
    "settings": {
      "read": false,
      "write": false,
      "delete": false
    },
    "dashboard": {
      "read": false,
      "write": false,
      "delete": false
    },
    "documents": {
      "read": false,
      "write": false,
      "delete": false
    },
    "transport": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsLibrary": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsHomework": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsSchedule": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsMaterials": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsAttendance": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsCurriculum": {
      "read": false,
      "write": false,
      "delete": false
    },
    "eventsCommunication": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsAssessments": {
      "read": false,
      "write": false,
      "delete": false
    },
    "academicsLessonPlans": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "settings": {
    "userManagement": {
      "read": false,
      "write": false,
      "delete": true
    },
    "complianceManagement": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "students": {
    "fees": {
      "read": false,
      "write": false,
      "delete": false
    },
    "events": {
      "read": false,
      "write": false,
      "delete": true
    },
    "scores": {
      "read": false,
      "write": false,
      "delete": false
    },
    "documents": {
      "read": false,
      "write": false,
      "delete": true
    },
    "attendance": {
      "read": false,
      "write": false,
      "delete": false
    },
    "studentList": {
      "read": false,
      "write": false,
      "delete": true
    }
  },
  "academics": {
    "library": {
      "read": false,
      "write": false,
      "delete": true
    },
    "materials": {
      "read": false,
      "write": false,
      "delete": true
    },
    "schedules": {
      "read": false,
      "write": false,
      "delete": true
    },
    "curriculum": {
      "read": false,
      "write": false,
      "delete": true
    },
    "assessments": {
      "read": false,
      "write": false,
      "delete": true
    },
    "lessonPlans": {
      "read": false,
      "write": false,
      "delete": true
    },
    "obep": {
      "read": false,
      "write": false,
      "delete": false
    },
    "courses": {
      "read": false,
      "write": false,
      "delete": false
    },
    "subjects": {
      "read": false,
      "write": false,
      "delete": false
    },
    "classes": {
      "read": false,
      "write": false,
      "delete": false
    },
    "scoringRubrics": {
      "read": false,
      "write": false,
      "delete": false
    },
    "syllabus": {
      "read": false,
      "write": false,
      "delete": false
    },
    "syllabusAssignment": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "analytics": {
    "performance": {
      "read": false,
      "write": false,
      "delete": false
    },
    "customDashboards": {
      "read": false,
      "write": false,
      "delete": true
    }
  },
  "dashboard": {
    "events": {
      "read": false,
      "write": false,
      "delete": true
    },
    "people": {
      "read": false,
      "write": false,
      "delete": false
    },
    "finance": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "administration": {
    "inventory": {
      "read": false,
      "write": false,
      "delete": true
    },
    "transport": {
      "read": false,
      "write": false,
      "delete": true
    },
    "healthAndSafety": {
      "read": false,
      "write": false,
      "delete": false
    }
  },
  "communications": {
    "events": {
      "read": false,
      "write": false,
      "delete": true
    },
    "concerns": {
      "read": false,
      "write": false,
      "delete": false
    },
    "meetings": {
      "read": false,
      "write": false,
      "delete": true
    },
    "messaging": {
      "read": false,
      "write": false,
      "delete": true
    },
    "announcements": {
      "read": false,
      "write": false,
      "delete": true
    }
  }
}